<div class="skeleton-loader" [ngStyle]="{ width: width, height: height, 'border-radius': borderRadius, margin: margin }"></div>
